// ═══════════════════════════════════════════════════════════════════
//  socle/api.js
//  Adresse de l'API, lecture du jeton, en-têtes authentifiés.
// ═══════════════════════════════════════════════════════════════════

export const API_BASE = "";

export function decodeToken(token) {
  try {
    const payload = token.split(".")[1];
    return JSON.parse(atob(payload));
  } catch {
    return null;
  }
}

export function authHeaders(token){ return { Authorization:`Bearer ${token}`, "Content-Type":"application/json" }; }
